import React from 'react';
import { Switch, Route } from 'react-static';
// eslint-disable-next-line
import Routes from 'react-static-routes';

import dynamicRoutes from './routes-dynamic';

const DynamicRoutes = () => (
  <Switch>
    {dynamicRoutes.map(route => (
      <Route key={route.path} path={route.path} component={route.component} />
    ))}
    <Routes />
  </Switch>
);

export default DynamicRoutes;



// WEBPACK FOOTER //
// /opt/build/repo/src/modules/DynamicRouter.js